import React, { useState, useEffect } from 'react';
import { Container, Form, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faFileExport } from '@fortawesome/free-solid-svg-icons';

import { useNavigate } from 'react-router-dom';

import { toast } from 'react-toastify';

import { useAuth } from '../Context/AuthContext';
import StatusSpinner from '../Components/StatusSpinner';

import { db } from '../firebase-config';
import { onSnapshot, doc } from 'firebase/firestore';

import { getFunctions, httpsCallable } from "firebase/functions";

import {inputMaxLengths} from '../HelperFunctions/InputMaxLengths';

const ClientQuote = ()=>{
    const { currentUserInfo, setShowSpinner, showSpinner } = useAuth();
    const [clientLocations, setClientLocations ] = useState([]);
    const [clientLocation, setClientLocation] = useState({});
    const [details, setDetails] = useState("");
    const [customer, setCustomer] = useState("");
    const [detailLettersRemaining, setDetailLetterRemaining] = useState(inputMaxLengths.details);
    const navigate = useNavigate();

    const requestType = 'quote';
    const typeOfService = '';

    useEffect(()=>{
        setShowSpinner(true);
        let unsubscribe = ()=>{};
        if(currentUserInfo?.links?.client){
            const clientInfoRef = doc(db, "client_information", currentUserInfo.links.client);
            unsubscribe = onSnapshot(clientInfoRef, (clientSnapShot)=>{
                if(clientSnapShot.exists()){
                    let tempClientLocations = [];
                    setCustomer(clientSnapShot.data()?.Customer);
                    tempClientLocations = clientSnapShot.data().Locations
                        .filter(location => currentUserInfo.links.locations.includes(location.id))
                        .map(({
                            "Additional Contacts": additionalContacts,
                            "Address": address,
                            "Client Name": clientName,
                            "Email Address": emailAddress,
                            "Phone Number": phoneNumber,
                            "Invoices": invoices,
                            "id": ID
                        }) => ({
                            additionalContacts,
                            address,
                            clientName,
                            emailAddress,
                            phoneNumber,
                            invoices,
                            ID
                        }));
                    setClientLocations(tempClientLocations);
                    setShowSpinner(false);
                }else{
                    toast.error(`Client does not exixt in database, please contact the Provengroup`);
                }
            },(error)=>{
                toast.error(`Failed to load client database: ${error.message}`);
                setShowSpinner(false);
            });
        }else{
            setClientLocations([]);
            setShowSpinner(false);
        }

        return ()=>{
            // console.log("unsubscribe to from client snapshot");
            unsubscribe();
        }
    },[setShowSpinner, currentUserInfo]);

    const updateDetailInfo = (detailInput)=>{
        setDetails(detailInput);
        const result = inputMaxLengths.details - detailInput.length;
        setDetailLetterRemaining(result);
    };

    const submit = ()=>{
        if(details !== "" && clientLocation?.address !== undefined){
            setShowSpinner(true);
            const functions = getFunctions();
            const clientRequest = httpsCallable(functions, 'clientRequest');
            clientRequest({
                status: 1,
                client_id: currentUserInfo.links.client,
                client_location_id: clientLocation?.ID,
                client: customer,
                type: requestType,
                'client name': clientLocation?.clientName,
                'email address': clientLocation?.emailAddress,
                'phone number': clientLocation?.phoneNumber,
                address: clientLocation.address,
                'type of service': requestType === 'quote' ? 'not applicable - Quote' : typeOfService,
                details: details,      
            }).then((response)=>{
                setShowSpinner(false);
                if(response.data.info === 'request added'){
                    toast.success(`Your Request for a Quote at: ${clientLocation.address} with ID - ${response.data.id} has been submitted. The Proven Group will contact you shortly.`);
                    setClientLocation({});
                    setDetails("");
                }else{
                    toast.error(`Could not submit request for: ${clientLocation.address}. Please contact admin.`);
                }
            }).catch((error)=>{
                setShowSpinner(false);
                toast.error(`Could not submit request for: ${clientLocation.address}. Please contact admin.`);
            });
        }else{
            setShowSpinner(false);
            toast.error('Please select a location and details');
        }
    };
    
    return(
        <>
            <div style={{display: 'flex', flexDirection: "row", alignItems:"center", justifyContent:"center", position:"relative"}}>
                <div className="mt-5" style={{position:"absolute", left:0}}>
                    <Button
                        className="btn-dark"
                        style={{backgroundColor:"#FFFFFF", border:"none", width: 75, marginLeft: 20}}
                        onClick={()=>{
                            navigate("/client");
                        }}
                        >
                        <FontAwesomeIcon style={{color: "#2596be", fontSize: '1.5em'}} icon={faArrowLeft} />
                        <span style={{color:"black"}}>HOME</span>
                    </Button>
                </div>
                <div className="mt-5" style={{fontSize:"1.5em", letterSpacing:"0.2em"}}>REQUEST FOR QUOTE</div>     
            </div>
            <Container fluid className="d-flex align-items-center justify-content-center" style={{width:"100%"}}>
            <div className="w-100" style={{maxWidth: "600px"}}>
                <div className="mt-5">
                    <Form.Group  style={{textAlign:"left"}} id="client-quote">
                        <Form.Label>Location</Form.Label>
                        <Form.Select value={clientLocation.address} onChange={(event)=>{
                            if(event.target.value !== ""){
                                setClientLocation(clientLocations.find((location)=> location.address === event.target.value));
                            }else{
                                setClientLocation({
                                    additionalContacts: undefined,
                                    address:undefined,
                                    clientName: undefined,
                                    emailAddress: undefined,
                                    phoneNumber: undefined,
                                    invoices: undefined,
                                    id: undefined,
                                });
                            }
                        }}>
                            <option value=""></option>
                            {
                                clientLocations.map((location, index)=>{
                                    return(<option key={index} value={location.address}>{location.address}</option>)
                                })
                            }
                        </Form.Select>
                        <Form.Label className="mt-4">Client Name</Form.Label>
                        <Form.Control
                            className="mt-1"
                            type="text"
                            value={clientLocation.clientName === undefined ? "" : clientLocation.clientName}
                            disabled={true}
                        />
                        <Form.Label className="mt-4">Email Address</Form.Label>
                        <Form.Control
                            className="mt-1"
                            type="text"
                            value={clientLocation.emailAddress === undefined ? "" : clientLocation.emailAddress}
                            disabled={true}
                        />
                        <Form.Label className="mt-4">Phone Number</Form.Label>
                        <Form.Control
                            className="mt-1"
                            type="text"
                            value={clientLocation.phoneNumber === undefined ? "" : clientLocation.phoneNumber}
                            disabled={true}
                        />
                        <Form.Label className="mt-4">Address</Form.Label>
                        <Form.Control
                            className="mt-1"
                            type="text"
                            value={clientLocation.address === undefined ? "" : clientLocation.address}
                            disabled={true}
                        />
                        <Form.Label className="mt-4">Details</Form.Label>
                        <Form.Control as="textarea" value={details} rows={3} maxLength={inputMaxLengths.details} onChange={(e)=> updateDetailInfo(e.target.value)} />
                        <div className="mt-4" style={{textAlign:"center"}}>{detailLettersRemaining} characters remaining</div>
                    </Form.Group>
                </div>
                <div style={{marginTop: 40, display: 'flex', flexDirection: "column", alignItems:"center"}}>
                    <Button
                        className="btn-dark"
                        style={{backgroundColor:"#FFFFFF", border: "none", marginTop: 30, width: 256, marginBottom: 60}}
                        onClick={()=>{
                            submit();
                        }}
                        >
                        <FontAwesomeIcon style={{color: "#2596be", fontSize: '4em', margin:10}} icon={faFileExport} />
                        <p style={{color:"#000000", fontSize: '1em', margin:10}}>SUBMIT REQUEST</p>
                    </Button>
                </div>
            </div>
            </Container>
            {
                showSpinner &&
                <StatusSpinner />
            }
        </>
    )
};

export default ClientQuote;